import React from 'react';
import { components } from 'react-select';
import css from '../styles.module.scss';

const ValueContainer: typeof components['ValueContainer'] = ({
  children,
  hasValue,
  ...props
}: any) => {
  const childrenArray = React.Children.toArray(children);

  const placeholder = childrenArray.find(
    (child) =>
      React.isValidElement(child) && child.type === components.Placeholder,
  );

  const input = childrenArray.find(
    (child) => React.isValidElement(child) && child.type === components.Input,
  );

  const showMenu = props.selectProps.menuIsOpen;

  if (!hasValue) {
    return (
      <components.ValueContainer {...props}>
        {children}
      </components.ValueContainer>
    );
  }

  if (showMenu) {
    return (
      <components.ValueContainer {...props}>
        {!props.selectProps.inputValue && placeholder}
        {input}
      </components.ValueContainer>
    );
  }

  const CHIPS_LIMIT = 1;
  const [chips, otherChildren] = children;
  const overflowCounter = chips.slice(CHIPS_LIMIT).length;

  const displayChips = chips.slice(
    overflowCounter,
    overflowCounter + CHIPS_LIMIT,
  );

  return (
    <components.ValueContainer {...props} className={css.chipsContainer}>
      {displayChips}

      {overflowCounter > 0 && (
        <span className={css.incriment}>+{`${overflowCounter}`}</span>
      )}

      {otherChildren}
    </components.ValueContainer>
  );
};

export default ValueContainer;
